import React, { useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Divider from '@material-ui/core/Divider';
import Pagination from '@material-ui/lab/Pagination';
import { ContactIntegratedList } from '~/interfaces/integrations';
import {
  IntegrationIds,
  integrationContactState,
} from '~/helpers/contactsIntegration';
import { openExternalURL } from '~/helpers';
import ContactList from './ContactList';
import SaveContact from './SaveContact';
import {
  ExpansibleContactsContainer,
  Accordion,
  AccordionSummary,
  Avatar,
  Typography,
  AccordionDetails,
  PaginationContainer,
} from './styles';

import CustomUrlPNG from '../../../assets/images/url.png';

type Props = {
  contacts: ContactIntegratedList;
  backgroundcolor?: string | undefined;
  bordercolor?: string | undefined;
  borderradius?: number;
  border?: string;
  expanded?: boolean;
};

/**
 * NOTE: This component was designed initially focus on Active Calls usage.
 * All default props is considering the primary usage, the Active Call Page.
 * We are exposing props in order to ajust the component to be also used in Call Details Page.
 */
function ExpansibleContacts(props: Props) {
  const { contacts, expanded: expandedProps } = props;

  const [expanded, setExpanded] = useState(expandedProps);

  const [page, setPage] = useState(1);

  // Use array destructuring to get the first contact integrationId
  // @ts-ignore
  const [firstContact] = contacts;
  const { integrationInfo, contactState, integrationId } = firstContact;

  const isCustomUrls = integrationId === IntegrationIds.CUSTOM_URLS_ID;

  // Note: NaN refer to custom URLs
  const isContact = contactState === integrationContactState.CREATED;
  const isDraft = contactState === integrationContactState.DRAFT;

  const accordionProps = {
    ...(isContact ? { expandIcon: <ExpandMoreIcon /> } : {}),
  };

  // @ts-ignore
  const handleChange = (event, value) => {
    setPage(value);
  };

  const limitPerPage = 3;
  const indexOfLastContact = page * limitPerPage;
  const indexOfFirstContact = indexOfLastContact - limitPerPage;
  const paginateContacts = contacts.slice(
    indexOfFirstContact,
    indexOfLastContact
  );

  const contactCount = contacts?.length || 0;
  const hasMultipleContacts = contactCount > 1;
  const contactsPerPage = Math.ceil(contactCount / limitPerPage);

  // Check if the integration is GoHighLevel 65.1203
  const isGoHighLevel = String(integrationId).startsWith(
    IntegrationIds.GO_HIGH_LEVEL_ID.toString()
  );

  const getAccordionSummaryHeadline = (
    integrationName: string | undefined
  ): string => {
    if (isGoHighLevel) {
      return hasMultipleContacts
        ? 'Multiple Records on GoHighLevel'
        : 'Record on GoHighLevel';
    }

    return hasMultipleContacts
      ? `Multiple Records on ${integrationName}`
      : `Record on ${integrationName}`;
  };

  return (
    <ExpansibleContactsContainer>
      {isCustomUrls ? (
        <div className="custom-urls-container">
          {contacts?.map(customUrl => (
            // @ts-ignore
            <Accordion key={customUrl?.name} {...props} expanded={false}>
              <AccordionSummary {...accordionProps}>
                <Avatar
                  alt="Custom Urls logo"
                  variant="square"
                  src={CustomUrlPNG}
                />
                <Typography
                  // @ts-ignore
                  onClick={() => openExternalURL(customUrl?.url)}>
                  Check {customUrl?.fullNameFormatted || customUrl?.firstName}{' '}
                  {/* @ts-ignore */}
                  on {customUrl?.name}
                </Typography>
              </AccordionSummary>
            </Accordion>
          ))}
        </div>
      ) : (
        <Accordion
          {...props}
          expanded={expanded}
          onChange={() => setExpanded(!expanded)}>
          <AccordionSummary {...accordionProps}>
            <Avatar
              alt="Integration logo"
              variant="square"
              src={integrationInfo.logo}
            />
            {isDraft ? (
              <SaveContact contact={firstContact} />
            ) : (
              <Typography>
                {getAccordionSummaryHeadline(integrationInfo.name)}
              </Typography>
            )}
          </AccordionSummary>

          {isContact && (
            <AccordionDetails>
              <ContactList key={integrationId} contacts={paginateContacts} />
              {!isGoHighLevel ? (
                <div>
                  <Divider />
                  <PaginationContainer>
                    <Pagination
                      size="small"
                      shape="rounded"
                      count={contactsPerPage}
                      page={page}
                      onChange={handleChange}
                    />
                  </PaginationContainer>
                </div>
              ) : null}
            </AccordionDetails>
          )}
        </Accordion>
      )}
    </ExpansibleContactsContainer>
  );
}

ExpansibleContacts.defaultProps = {
  borderradius: '10px',
  border: '1px solid',
  bordercolor: '#dadada',
  backgroundcolor: undefined,
  expanded: true,
};

export default ExpansibleContacts;
